export default __webpack_public_path__ + "static/media/entradageneral_registro_bco.28fde71b.png";